<div class="card-comparativo">

    <img class="background-relatorio" src="assets/img/capa-relatorio-comparativo.jpeg">

    <div class="card-overlay">
        <div class="card-top">
            <status-badge [tipo]="badge.tipo" [label]="badge.label" [detalhe]="badge.detalhe"
                [tooltip]="disponivel ? '' : tooltipCadeado()"></status-badge>

            <div class="card-title" [ngClass]="{'card-title--bloqueado': !disponivel}">
                Relatório de Comparação
            </div>
            <div class="card-subtitle" *ngIf="nomesTestes">{{ nomesTestes }}</div>
        </div>

        <div class="card-actions">
            <div class="card-actions__row">
                <button [disabled]="!disponivel" mat-mini-fab color="primary" (click)="iniciar()">
                    <mat-icon>assignment</mat-icon>
                </button>
                <span class="ms-3">Ver relatório</span>
            </div>
            <div class="card-progresso">{{ concluidas }} de {{ total }} concluídos</div>
        </div>
    </div>

    <img *ngIf="!disponivel" class="cadeado" src="assets/img/cadeado.svg" [matTooltip]="tooltipCadeado()"
        [matTooltipShowDelay]="600">
</div>
